var _defs, _path, _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgCaptureLicense = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  xmlnsXlink: "http://www.w3.org/1999/xlink",
  viewBox: "0 0 400 400"
}, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "g",
  x1: 3.5,
  x2: 1,
  y1: 5.1,
  y2: 5.3,
  gradientUnits: "userSpaceOnUse",
  spreadMethod: "pad"
}, /*#__PURE__*/React.createElement("stop", {
  offset: "4%",
  stopColor: "#B5B5B5"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "36%",
  stopColor: "#E2E2E2"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "100%",
  stopColor: "#FFF"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "f",
  x1: 3.5,
  x2: 1,
  y1: 5.1,
  y2: 5.3,
  gradientUnits: "userSpaceOnUse",
  spreadMethod: "pad"
}, /*#__PURE__*/React.createElement("stop", {
  offset: "17%",
  stopColor: "#BDBDBD"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "64%",
  stopColor: "#E1E1E1"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "100%",
  stopColor: "#DDD"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "e",
  x1: 14.9,
  x2: 14.9,
  y1: 9.3,
  y2: 25,
  gradientUnits: "userSpaceOnUse",
  spreadMethod: "pad"
}, /*#__PURE__*/React.createElement("stop", {
  offset: "0%",
  stopColor: "#B1B1B1"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "100%",
  stopColor: "#FFF"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "d",
  x1: 75.4,
  x2: 34.9,
  y1: 37.4,
  y2: 90.1,
  gradientUnits: "userSpaceOnUse",
  spreadMethod: "pad"
}, /*#__PURE__*/React.createElement("stop", {
  offset: "0%",
  stopColor: "#FFF"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "100%",
  stopColor: "#FFF",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "b",
  x1: 155.5,
  x2: 112,
  y1: 118.8,
  y2: 146.5,
  gradientUnits: "userSpaceOnUse",
  spreadMethod: "pad"
}, /*#__PURE__*/React.createElement("stop", {
  offset: "0%",
  stopColor: "#FFF"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "100%",
  stopColor: "#FFF",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("filter", {
  id: "c",
  width: "100%",
  height: "100%",
  x: "0%",
  y: "0%"
}, /*#__PURE__*/React.createElement("feGaussianBlur", {
  in: "SourceAlpha",
  result: "filter_result_0_drop_shadow_1",
  stdDeviation: 6.1
}), /*#__PURE__*/React.createElement("feOffset", {
  dx: 3.3,
  in: "filter_result_0_drop_shadow_1",
  result: "filter_result_0_drop_shadow_2"
}), /*#__PURE__*/React.createElement("feFlood", {
  floodColor: "#000",
  floodOpacity: 0.1,
  result: "filter_result_0_drop_shadow_3"
}), /*#__PURE__*/React.createElement("feComposite", {
  in: "filter_result_0_drop_shadow_3",
  in2: "filter_result_0_drop_shadow_2",
  operator: "in",
  result: "filter_result_0_drop_shadow_4"
}), /*#__PURE__*/React.createElement("feMerge", {
  result: "filter_result_0"
}, /*#__PURE__*/React.createElement("feMergeNode", {
  in: "filter_result_0_drop_shadow_4"
}), /*#__PURE__*/React.createElement("feMergeNode", {
  in: "SourceGraphic"
}))), /*#__PURE__*/React.createElement("path", {
  id: "a",
  d: "M8 0h145a8 8 0 0 1 8 8v258a8 8 0 0 1-8 8H8a8 8 0 0 1-8-8V8a8 8 0 0 1 8-8"
}), /*#__PURE__*/React.createElement("mask", {
  id: "h",
  "mask-type": "alpha"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#a"
})))), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "var(--thc-color-primary-light-yellow)",
  d: "M347.9 200a148.5 148.5 0 1 1-297 0 148.5 148.5 0 0 1 297 0"
})), _g || (_g = /*#__PURE__*/React.createElement("g", {
  "data-id-hand": "true"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#DEDEDE",
  fillOpacity: 0.8,
  d: "M201.4 108.9c.2-6-16.3-5.5-22.8-6-24.3-2.2-25.7-3.3-39.5-5.4-92.7 2-50.3 14-132.1 43.4A40.7 40.7 0 0 0-14.5 159c-17.8 31.1-36.7 61.4-62 88.5-33 30-24.1 82.2-19.4 98.6 13.5 33 75.8-16 92.2-17.2 9.2-.4 25.2.2 34-3.1 41-21.5 48-16.5 83.4-16.5 6.8 0 31.5-7.3 31.5-7.3 16.2 0 33-1.6 33-6.3 0-32-72-18.2-92-20.3-22 .2-29-23.5-37.6-43.5a55 55 0 0 1 4.7-51.7 475 475 0 0 1 28.8-40.4c28.4-26.4 117.7 20.6 119.3-31z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "none",
  stroke: "url(#b)",
  strokeOpacity: 0.5,
  strokeWidth: 4,
  d: "M302 11.4c.2-6-16.3-5.5-22.8-6C255 3.3 253.6 2 239.7 0c-92.7 2-50.3 14-132 43.5a40.7 40.7 0 0 0-21.6 18C68.3 92.7 49.4 123 24 150c-32.8 30-24 82.2-19.3 98.6 13.6 33 75.8-16 92.2-17.2 9.3-.3 25.3.2 34-3 41-21.5 48-16.5 83.4-16.5 6.8 0 31.5-7.4 31.5-7.4 16.2 0 33-1.6 33-6.3 0-32-72-18.2-92-20.3-22 .2-29-23.5-37.6-43.5a55 55 0 0 1 4.7-51.7c8.5-12.9 17-25.7 28.8-40.3 28.4-26.5 117.7 20.5 119.3-31z",
  transform: "translate(-100.6 97.5)"
}), /*#__PURE__*/React.createElement("g", {
  filter: "url(#c)",
  transform: "translate(-23.6 25.5)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#FFF",
  d: "M351.7 97c.6 0 1 .1 1.6.3a4.1 4.1 0 0 1 1.4 1 4.1 4.1 0 0 1 1 1.4 4.1 4.1 0 0 1 .3 1.6v143.4c0 .6-.1 1-.3 1.6a4.1 4.1 0 0 1-1 1.4 4.1 4.1 0 0 1-1.4 1 4.1 4.1 0 0 1-1.6.3H96.3c-.6 0-1-.1-1.6-.3a4.1 4.1 0 0 1-1.4-1 4.1 4.1 0 0 1-1-1.4 4.1 4.1 0 0 1-.3-1.6V101.3c0-.6.1-1 .3-1.6a4.1 4.1 0 0 1 1-1.4 4.1 4.1 0 0 1 1.4-1 4.1 4.1 0 0 1 1.6-.3z"
})), /*#__PURE__*/React.createElement("path", {
  fill: "#FFF",
  d: "M328 122.5c.7 0 1.2 0 1.7.3a4.1 4.1 0 0 1 1.4 1 4.1 4.1 0 0 1 1 1.3 4.1 4.1 0 0 1 .3 1.7v143.4c0 .6-.1 1-.4 1.6a4.1 4.1 0 0 1-.9 1.4 4.1 4.1 0 0 1-1.4 1 4.1 4.1 0 0 1-1.6.3H72.7c-.6 0-1.1-.1-1.7-.4a4.1 4.1 0 0 1-1.4-.9 4.1 4.1 0 0 1-.9-1.4 4.1 4.1 0 0 1-.3-1.6V126.8c0-.6 0-1.1.3-1.7a4.1 4.1 0 0 1 1-1.4 4.1 4.1 0 0 1 1.3-.9 4.1 4.1 0 0 1 1.7-.3z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#e4e4e4",
  d: "M316.4 154.5h.4a1 1 0 0 1 .3.3 1 1 0 0 1 .2.3 1 1 0 0 1 0 .4v3a1 1 0 0 1 0 .4 1 1 0 0 1-.2.3 1 1 0 0 1-.3.2 1 1 0 0 1-.4 0h-232a1 1 0 0 1-.4 0 1 1 0 0 1-.3-.2 1 1 0 0 1-.3-.3 1 1 0 0 1 0-.4V155a1 1 0 0 1 .3-.3 1 1 0 0 1 .3-.2 1 1 0 0 1 .4-.1h232zm-152 26h59a1 1 0 0 1 1 1v8a1 1 0 0 1-1 1h-59a1 1 0 0 1-1-1v-8a1 1 0 0 1 1-1m0 19h59a1 1 0 0 1 1 1v8a1 1 0 0 1-1 1h-59a1 1 0 0 1-1-1v-8a1 1 0 0 1 1-1m0 19h83a1 1 0 0 1 1 1v8a1 1 0 0 1-1 1h-83a1 1 0 0 1-1-1v-8a1 1 0 0 1 1-1m0 19h25a1 1 0 0 1 1 1v7a1 1 0 0 1-1 1h-25a1 1 0 0 1-1-1v-7a1 1 0 0 1 1-1m-80-104h110a1 1 0 0 1 1 1v9a1 1 0 0 1-1 1h-110a1 1 0 0 1-1-1v-9a1 1 0 0 1 1-1m211-1h21a1 1 0 0 1 1 1v9a1 1 0 0 1-1 1h-21a1 1 0 0 1-1-1v-9a1 1 0 0 1 1-1"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#EAEAEA",
  d: "M5.1 207.4c8.3.3 15.9-4.5 22.1-10a95 95 0 0 0 19.7-23.7c3.8-6.6 6.9-13.6 11-20 7.1-10.8 11.9-22.1 18-33.5 11.6-.3 25.6 1.2 40.1-3.1a74.8 74.8 0 0 0 27.7 6.2c6 .2 12.3-.4 17.4-3.6 5.2-3 9.3-9.2 8-15-1.5-3.5-18.8-7.7-28.5-10.2-8.3-6.1-18-6.2-28.3-6.4s-26.4-.3-36.5 0c-10 .3-16.1-2.5-21.7 1.6-26.6 19.8-33.1 49-61.6 66a60 60 0 0 0-2.6 28.8c2 9.4 7.4 17.2 15.2 23z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "none",
  stroke: "url(#d)",
  strokeOpacity: 0.7,
  strokeWidth: 3.3,
  d: "M15.3 118.4c8.2.6 16-4 22.3-9.3A95 95 0 0 0 58 85.9c4-6.5 7.3-13.5 11.6-19.7C77 55.6 82 44.4 88.3 33.2c11.7 0 25.7 1.8 40.3-2a74.8 74.8 0 0 0 27.4 7c6 .3 12.4-.2 17.6-3.2s9.5-9 8.3-14.9c-1.3-3.4-18.5-8.1-28.1-10.8-8.1-6.4-17.8-6.7-28.1-7.2S99.2 1 89.2 1s-16-3-21.7 1C40.3 21 33 50.2 4 66.4A60 60 0 0 0 .6 95.1c1.9 9.5 7 17.4 14.7 23.3z",
  transform: "rotate(-2 3264.3 487.3)"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#F2F2F2",
  d: "M150.6 174.3v74a5 5 0 0 1-5 5h-59a5 5 0 0 1-5-5v-74a5 5 0 0 1 5-5h59a5 5 0 0 1 5 5"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#e)",
  d: "M6.8 20.1v.2c0 2.7-2.3 4.7-6.8 6 5.4 4 10.9 7.2 16.3 7.2 5.5 0 11-3.2 16.4-7.1-4.5-1.4-6.8-3.4-6.8-6.1V8.2q.45 0 0 0V4.4C26 0 6.5-4.2 7 8.5V20z",
  transform: "translate(99.8 205.3)"
}), /*#__PURE__*/React.createElement("path", {
  fill: "var(--thc-color-dark-grey)",
  d: "M150.6 240.8v7.5a5 5 0 0 1-5 5h-59a5 5 0 0 1-5-5V241c3.2-5.7 21.9-11 21.9-11 1.7 3 6.8 6 12 6 5.6.2 11.4-2.7 13.2-6 0 0 18.7 5 21.9 10.8"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#CDCDCD",
  d: "M106.3 219.2c8-.9 15.5 2.6 15.5 2.6s-1.5 7.8-15.5 5.5v-8z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#f)",
  d: "M4 1.4v8c-.2.6-.6 1-1.7 1C1 10.4.4 6.6.3 5.3 0 3.9-.6 2.8 1 .8 2.3-1 3.5.5 3.8 1.4z",
  transform: "matrix(1 -.1 0 1 98.6 202.2)"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#g)",
  d: "M4 1.4v8c-.2.6-.6 1-1.7 1C1 10.4.4 6.6.3 5.3 0 3.9-.6 2.8 1 .8 2.3-1 3.5.5 3.8 1.4z",
  transform: "matrix(-1 -.1 -.1 1 133 202.6)"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FAFAFA",
  d: "M130.9 204.6c0 11.4-8.3 20.7-14.7 20.7-7.1 0-14.8-9.3-14.8-20.7 0-10.1.9-21 14.7-21s14.8 10.6 14.8 21"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#e4e4e4",
  d: "M84.4 133.5h110a1 1 0 0 1 1 1v9a1 1 0 0 1-1 1h-110a1 1 0 0 1-1-1v-9a1 1 0 0 1 1-1"
}))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  mask: "url(#h)",
  transform: "rotate(-90 171.5 108.5)"
}, /*#__PURE__*/React.createElement("path", {
  stroke: "var(--thc-color-light-grey)",
  strokeWidth: 6,
  d: "M8 0h145a8 8 0 0 1 8 8v258a8 8 0 0 1-8 8H8a8 8 0 0 1-8-8V8a8 8 0 0 1 8-8z"
}))));
export { SvgCaptureLicense as ReactComponent };
export default new URL("/home/runner/_work/motorway-seller-webapp/motorway-seller-webapp/src/shared/containers/app/documentCapture/uploadDocuments/pages/IncodeSDKPage/assets/CaptureLicense.svg", import.meta.url).toString();